/**
 * @file
 * Mapbox code for "job detail" page.
 */

import 'polyfill-array-includes';
import bbox from '@turf/bbox';
import {
  mapboxAccessToken,
} from '../../utils/MapUtils';


(($, Drupal, mapboxgl) => {
  Drupal.behaviors.jobDetailMapInit = {
    attach(context, settings) {

        if (!$('.job--detail-map', context).length) {
          return;
        }

        let type = 'Point';
        let coords = JSON.parse(settings.coordinates);

        if (coords[0].length > 1) {
          type = 'Polygon';
          coords = [coords];
        }

        const job = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: type,
                coordinates: coords,
              },
            },
          ],
        };

        mapboxgl.accessToken = mapboxAccessToken;
        const map = new mapboxgl.Map({
          container: 'jobDetailMap',
          style: 'mapbox://styles/didmapboxfrederik/ciz02ulow00032rnsyzqba92c?optimize=true',
          center: [4.1072426, 51.0925963],
          zoom: 14,
          interactive: false,
          attributionControl: true,
        });

        map.on('load', () => {
          map.addSource('location', {
            type: 'geojson',
            data: job,
          });

          if (type === 'Point') {
            map.addLayer({
              id: 'location',
              type: 'circle',
              source: 'location',
              paint: {
                'circle-color': '#B9D216',
                'circle-radius': 16,
                'circle-stroke-width': 8,
                'circle-stroke-color': '#fff',
                'circle-stroke-opacity': 0.85,
              }
            });
            map.setCenter(coords);
            map.setZoom(14);
          }

          if (type === 'Polygon') {
            map.addLayer({
              id: 'location',
              type: 'fill',
              source: 'location',
              paint: {
                'fill-color': '#FFA500',
                'fill-opacity': 0.8,
              }
            });

            const boundingBox = bbox(job);
            map.fitBounds(boundingBox, { padding: 40 });
          }
        });
    },
  };
})(jQuery, Drupal, mapboxgl);
